<template>
  <div class="maps d-flex flex-column flex-fill overflow-hidden">
    <AssetsMap />
  </div>
</template>

<script lang="ts">
import { defineComponent, watch } from 'vue'
import AssetsMap from '@/components/content/AssetsMap.vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'AssetsMapView',
  components: { AssetsMap },
  setup(props, context) {
    const i18n = useI18n()
    context.emit('pageName', i18n.t('aside.menu.pages.assetsMap'))

    watch(() => i18n.locale.value, () => {
      context.emit('pageName', i18n.t('aside.menu.pages.assetsMap'))
    })
  },
  /**
   * Pretty map rendering
   */
  mounted() {
    document.body.classList.add('map')
  },
  unmounted() {
    document.body.classList.remove('map')
  }
})
</script>

<style scoped>
.maps {
  padding: 0 !important;
  max-width: 100% !important;
  height: calc(100dvh - clamp(65px, 7vh, 110px));
  min-height: 480px;
  position: relative;
}

@media (min-width: 769px) {
  .maps {
    border-radius: 0.5rem;
  }
}

@media (max-width: 768px) {
  .maps {
    height: calc(100vh - 65px) !important;
    min-height: calc(100vh - 65px);
    position: fixed;
    top: 65px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    transition: height 0.3s ease;
  }

  body:not(.sidebar-open) .maps {
    height: calc(100vh - 65px) !important;
  }

  body.sidebar-open .maps {
    height: calc(45vh - 65px) !important;
    bottom: 55vh !important;
  }
}

@media (max-width: 480px) {
  .maps {
    height: calc(100vh - 55px) !important;
    min-height: calc(100vh - 55px);
    position: fixed;
    top: 55px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    transition: height 0.3s ease;
  }

  body:not(.sidebar-open) .maps {
    height: calc(100vh - 55px) !important;
  }

  body.sidebar-open .maps {
    height: calc(50vh - 55px) !important;
    bottom: 50vh !important;
  }
}
</style>
